/* eslint-disable react/no-children-prop */
import React from "react";
import { Spinner as ReactSpinner } from "reactstrap";
import PropTypes from "prop-types";

const propTypes = {
  size: PropTypes.string
};

const defaultProps = {
  size: ""
};

function Spinner(props) {
  const { size } = props;
  return (
    <div className="d-flex justify-content-center align-items-center h-100 w-100">
      {!size ? (
        <ReactSpinner style={{ width: "3rem", height: "3rem" }} children="" />
      ) : (
        <ReactSpinner size={size} children="" />
      )}
    </div>
  );
}

Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;

export default Spinner;
